import { Spinner } from '@talentmesh/ui/components/spinner';
import { TypographyH2, TypographyH4 } from '@talentmesh/ui/components/typography';
import { toast } from 'sonner';
import LabeledSwitch from './LabeledSwitch';
import { useAccountSettings, useUpdateNotificationSettings } from '@/api/useAccountSettings';
import { useNotificationContext } from '@/Context/NotificationContext';
import UIStrings from '@/Utils/UIStrings';

function AccountSettingsNotifications() {
    const { showSuccessToaster, showFailToaster } = useNotificationContext();
    const { data, isLoading } = useAccountSettings();
    const { sendNotificationsOnAssessmentComplete } = data.notifications;
    const { isMutating, trigger } = useUpdateNotificationSettings();

    const switchChangeHandler = async (checked: boolean) => {
        try {
            toast.dismiss();
            await trigger({ sendNotificationsOnAssessmentComplete: checked });
            showSuccessToaster(UIStrings.NotificationsSettingsHasBeenUpdatedSuccessfully);
        } catch {
            showFailToaster();
        }
    };

    return (
        <div className="flex flex-col gap-6">
            <TypographyH2>{UIStrings.AssessmentNotifications}</TypographyH2>
            <div className="flex flex-col gap-4">
                <TypographyH4 className="font-medium">{`${UIStrings.EmailMe}:`}</TypographyH4>
                {isLoading ? (
                    <Spinner />
                ) : (
                    <LabeledSwitch
                        disabled={isMutating}
                        label={UIStrings.WhenApplicantSubmitsAssessment}
                        onCheckedChange={switchChangeHandler}
                        checked={sendNotificationsOnAssessmentComplete}
                    />
                )}
            </div>
        </div>
    );
}

export default AccountSettingsNotifications;
